/* src/app/components/discovery/ai-review/ai-review.component.scss */
::ng-deep .ngx-charts g .grid-panel.odd rect {
  fill: none;
}
.inner-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 1px 2px #e0e0e0;
}
.inner-card-title {
  color: #979797;
}
.inner-card .mat-mdc-card-content {
  height: 80%;
}
:host-context(.dark-theme) .inner-card {
  border: none;
  box-shadow: 1px 2px 3px 2px rgba(0, 0, 0, 0.12);
  background-color: #3f3f3f;
}
:host-context(.dark-theme) .inner-card-title {
  color: #cbcbcb;
}
:host-context(.dark-theme) .inner-card .mat-mdc-card-content {
  background-color: #3f3f3f;
}
.pie-chart {
  position: relative;
}
.pie-chart-center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-weight: 200;
  text-align: center;
  color: #979797;
}
.grid {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  grid-template-rows: 55% 45%;
  grid-gap: 10px;
}
.table-for-graph {
  width: 90%;
  margin-left: 16px;
  border-collapse: collapse;
}
.table-for-graph tr:hover {
  background-color: #eeeeee;
}
.table-for-graph td {
  border: 1px solid #ddd;
  text-align: left;
  padding: 8px;
}
.table-for-graph .header {
  color: #979797;
  font-weight: 600;
}
:host-context(.dark-theme) .table-for-graph,
:host-context(.dark-theme) .table-for-graph td {
  border: 2px solid #656565;
}
:host-context(.dark-theme) .table-for-graph tr:hover {
  background-color: #424242;
}
.table-for-graph a,
.info-text a {
  color: blue;
  font-weight: initial;
}
.info-text {
  color: #979797;
}
.inner-card-title span,
.info-text span {
  color: initial;
  font-weight: 200;
}
:host-context(.dark-theme) .table-for-graph .header,
:host-context(.dark-theme) .info-text,
:host-context(.dark-theme) .pie-chart-center-text {
  color: #cbcbcb;
}
:host-context(.dark-theme) .inner-card-title span,
:host-context(.dark-theme) .info-text span {
  color: white;
}
:host-context(.dark-theme) .table-for-graph a,
:host-context(.dark-theme) .info-text a {
  color: #88a3ff;
}
::ng-deep .ngx-charts .arc-group .arc {
  cursor: initial;
}
::ng-deep .chart-legend .legend-label {
  cursor: default !important;
}
/*# sourceMappingURL=ai-review.component.css.map */
